/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JiraWorkspaceAri } from '@atlassian/ari/jira/workspace';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import parameters, {
	type ReportsOverviewPageQuery,
} from './__generated__/ReportsOverviewPageQuery.graphql.ts';

type Queries = { reportsOverviewPage: ReportsOverviewPageQuery };

type ReportsOverviewPageEntryPointComponent = EntryPointComponent<Queries, {}, {}, {}>;

export const reportsOverviewPageEntryPoint: EntryPoint<
	ReportsOverviewPageEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<ReportsOverviewPageEntryPointComponent>(
		/* webpackChunkName: "jira-reports-overview-page" */ './ReportsOverviewPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const boardId = context.match.params.boardId ? String(context.match.params.boardId) : null;
		const projectKey = context.match.params.projectKey
			? String(context.match.params.projectKey)
			: null;
		const isBoardContext = !!boardId;
		const isProjectContext = !!projectKey;
		const cloudId = tenantContext.cloudId;
		const workspaceAri = fg('avp_jira_space_dashboard_pass_workspace_ari')
			? JiraWorkspaceAri.create({
					siteId: cloudId,
					activationId: tenantContext.activationId,
				}).toString()
			: undefined;

		return {
			queries: {
				reportsOverviewPage: {
					options: {
						fetchPolicy: 'network-only' as const,
					},
					parameters,
					variables: {
						boardId: isBoardContext ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '',
						projectKey: !isBoardContext && isProjectContext ? projectKey : '',
						cloudId,
						isBoardContext,
						isMigrateTMPReportsOverviewEnabled: fg('uxissue_545_migrate_tmp_reports_overview_page'),
						isSunsetHideEnabled: fg('jira-cmp-report-sunset-hide'),
						avpProjectKey: isProjectContext ? projectKey : '',
						workspaceAri,
					},
				},
			},
		};
	},
});
